// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"dropzone_dropzone__2UIM8","thumb":"dropzone_thumb__1TmFO","thumbsContainer":"dropzone_thumbsContainer__AIXAf"};